import React, { useEffect, useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll'
import { 
    Nav, 
    NavbarContainer, 
    NavLogo, 
    MobileIcon, 
    NavMenu, 
    NavItem, 
    NavLinks,
    NavBtn,
    NavBtnLink 

} from './NavbarElements'

const Navbar = ({ toggle }) => {
    const [scrollNav, setScrollNav] = useState(false)

    const changeNav = () => {
        if(window.scrollY >= 80){
            setScrollNav(true)
        }
        else{
            setScrollNav(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav)
    }, [])

    const toggleHome = () => {
        scroll.scrollToTop()
    }

    return (
    <>
        <IconContext.Provider value={{color: '#fff'}}>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to="/" smooth={true} duration={500} spy={true} exact='true' offset={-80} onClick={toggleHome}>Home</NavLinks>
                        </NavItem>

                        <NavItem>
                            <NavLinks to="about" smooth={true} duration={500} spy={true} exact='true' offset={-80}>O mně</NavLinks>
                        </NavItem>

                        <NavItem>
                            <NavLinks to="stats" smooth={true} duration={500} spy={true} exact='true' offset={-80}>Statistiky</NavLinks>
                        </NavItem>

                        <NavItem>
                            <NavLinks to="games" smooth={true} duration={500} spy={true} exact='true' offset={-80}>Dohrané hry</NavLinks>
                        </NavItem>

                        <NavItem>
                            <NavLinks to="upcoming_games" smooth={true} duration={500} spy={true} exact='true' offset={-80}>Nadcházející hry</NavLinks>
                        </NavItem>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
        </IconContext.Provider>
    </>
  );
};

export default Navbar